import React, { useState } from 'react';
import ListItem from './listComponent/ListItem';
import ListView from './listComponent/ListView';
import Spacer from './layout/Spacer';
import Panel from './layout/Panel';
import SearchField from './layout/SearchField';
import Button from './layout/Button';
import ScopeCamera from '../classes/Camera';
import Engine from '../classes/Engine';
import ProjectSaver from '../classes/ProjectSaver';
import { SaveModificationTypes } from '../globals'
import TextUtils from '../classes/utilities/TextUtils';

export default function CameraPicker(props: {
	value: string;
	cameraSelectedCallback?: (cameraId: string) => void;
	onShutdown?: () => void;
})
{
	const [selectedCameraId, setSelectedCameraId] = useState(props.value);
	const [searchQuery, setSearchQuery] = useState("");
	const cameras = ScopeCamera.getSceneCameras(Engine.getInstance().getCurrentScene());

	function generateCameraList()
	{
		const items = new Array<JSX.Element>();

		items.push(
			<ListItem
				key={"None"}
				nodeId={""}
				label={" - None - "}
			/>
		);

		if (cameras)
		{
			Object.values<ScopeCamera>(cameras).forEach(cameraItem =>
			{
				if (TextUtils.searchString(cameraItem.name, searchQuery))
				{
					items.push(
						<ListItem
							key={cameraItem.userData.guid}
							nodeId={cameraItem.userData.guid}
							label={cameraItem.name}
							state={cameraItem.userData.guid === selectedCameraId ? "selected" : null}
						/>
					);
				}
			})
		}

		return items;
	}

	function onCameraSelected(selectedItem)
	{
		const value = selectedItem.values().next().value;
		if (value)
		{
			setSelectedCameraId(value.nodeId);
		}
		else
		{
			setSelectedCameraId("");
		}
	}

	function onCameraPicked()
	{
		if (props.cameraSelectedCallback)
		{
			props.cameraSelectedCallback(selectedCameraId);
			for (const camera of cameras)
			{
				if(camera.userData.guid === selectedCameraId)
				{
					ProjectSaver.getInstance().markModifiedObject(camera, SaveModificationTypes.Reference);
					break;
				}
			}
		}

		if (props.onShutdown)
		{
			props.onShutdown();
		}
	}

	return (
		<Panel className="solid composite"
			style={{
				maxHeight: "500px",
				maxWidth: "500px",
			}}
		>
			<SearchField value={searchQuery} onChangeCallback={(v) => setSearchQuery(v)} />
			<Spacer size={{ y: "2px" }} />
			<ListView
				selectedItems={new Set().add(selectedCameraId)}
				selectionChangedCallback={onCameraSelected}
				multiSelectEnabled={false}
				doubleClickCallback={onCameraPicked}
				dndDefaults={{
					dragEnabled: false,
					dropEnabled: false,
				}}
			>
				{
					generateCameraList()
				}
			</ListView>
			<Button
				silent={true}
				label="Confirm"
				onClick={onCameraPicked}
			/>
		</Panel>
	)
}